// removed by extract-text-webpack-plugin
module.exports = {"unit":"5px","colorPrimaryOrange":"#e16e46","colorSecondaryShadeOrange":"rgba(255, 142, 105, 0.7)","overline":"fonts__overline____WM0UA","pill":"pill__pill____2V7F5 fonts__overline____WM0UA","filled":"pill__filled____wXkyJ","bordered":"pill__bordered____3eUkC","overlaid":"pill__overlaid____2Szom"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/widgets/pill/pill.css
// module id = 534
// module chunks = 0